import React, { useEffect, useRef, useState } from 'react';
import api from './api';
import { timeAgo } from './helpers';

const ICONE_TYPE = {
  comment: '💬',
  assignment: '📌',
  delegation: '🤝',
  deadline: '⏰',
  mention: '📣',
};

// `onOuvrir` reçoit { projectId, taskId } : c'est App qui sait naviguer.
function Notifications({ userId, onOuvrir }) {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const rootRef = useRef(null);

  const load = () => {
    api.get('/notifications', { params: { userId } }).then((res) => setNotifications(res.data)).catch(() => {});
  };

  useEffect(load, [userId]);

  // Rafraîchissement périodique : sans cela, une notification arrivée pendant
  // que la page est ouverte ne se verrait qu'au prochain rechargement.
  useEffect(() => {
    const timer = setInterval(load, 60000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    if (!open) return;
    const handleOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [open]);

  const unreadCount = notifications.filter((n) => !n.is_read).length;

  const handleClick = async (n) => {
    if (!n.is_read) {
      try {
        await api.put(`/notifications/${n.id}/read`);
        setNotifications(notifications.map((x) => (x.id === n.id ? { ...x, is_read: true } : x)));
      } catch (err) {
        // ignore
      }
    }
    setOpen(false);

    // On emmène la personne là où l'information se trouve : la tâche
    // concernée si la notification en désigne une, sinon le projet.
    if (onOuvrir && (n.task_id || n.project_id)) {
      onOuvrir({ projectId: n.project_id, taskId: n.task_id });
    }
  };

  return (
    <div style={{ position: 'relative' }} ref={rootRef}>
      <button className="icon-btn" onClick={() => setOpen(!open)}>
        🔔
        {unreadCount > 0 && <span className="notif-dot" />}
      </button>

      {open && (
        <div className="notif-dropdown">
          <div className="notif-dropdown-header">Notifications {unreadCount > 0 && `(${unreadCount})`}</div>
          {notifications.length === 0 && <div className="notif-empty">Aucune notification.</div>}
          {notifications
            .slice()
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .map((n) => (
              <div
                key={n.id}
                className={`notif-item ${!n.is_read ? 'unread' : ''}${n.task_id || n.project_id ? ' notif-item-cliquable' : ''}`}
                onClick={() => handleClick(n)}
                title={n.task_id ? 'Ouvrir la tâche' : n.project_id ? 'Ouvrir le projet' : undefined}
              >
                <div>
                  <span style={{ marginRight: 6 }}>{ICONE_TYPE[n.type] || '•'}</span>
                  {n.message}
                </div>
                <div className="notif-item-time">{timeAgo(n.created_at)}</div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default Notifications;
